export const CLEAR_INVOICE = 'CLEAR_INVOICE'

export const clearInvoice = () => ({
  type: CLEAR_INVOICE,
})
